import * as React from "react";
import { GraduationCap } from "lucide-react";
import { ImageLoader } from "../../../ImageLoader";
import { ListViewCard } from "../ListViewCard";
import type { ListViewCardAction, ListViewCardLayout, ListViewCTAGroup } from "../ListViewCard";
import { isContentLocKey } from "@/app/lib/i18n/contentKeys";
import { useCertificationContentDefinitions } from "@/app/lib/i18n/useCertificationContentDefinitions";

export interface ListViewCertificationModuleCardModule {
  id: string;
  title: string;
  slug: string;
  heroImageUrl?: string | null;
  isActive: boolean;
}

export interface ListViewCertificationModuleCardProps {
  layout: ListViewCardLayout;
  module: ListViewCertificationModuleCardModule;
  contextActions?: ListViewCardAction[];
  onClick?: () => void;
  ctaGroups?: ListViewCTAGroup[];
}

export function ListViewCertificationModuleCard({
  layout,
  module: mod,
  contextActions,
  onClick,
  ctaGroups,
}: ListViewCertificationModuleCardProps) {
  const { resolve } = useCertificationContentDefinitions();
  const title = isContentLocKey(mod.title) ? resolve(mod.title) || "…" : mod.title;

  const image = mod.heroImageUrl ? (
    <ImageLoader src={mod.heroImageUrl} />
  ) : (
    <GraduationCap size={layout === "deck" ? 40 : 32} style={{ opacity: 0.55 }} />
  );

  const statusBadge = mod.isActive
    ? { id: "status", label: "Active", variant: "active" as const }
    : { id: "status", label: "Inactive", variant: "disabled" as const };

  return (
    <ListViewCard
      id={mod.id}
      layout={layout}
      imageFormat="cover"
      image={image}
      title={title}
      subtitle={mod.slug}
      badges={[statusBadge]}
      onClick={onClick}
      contextActions={contextActions}
      ctaGroups={ctaGroups}
    />
  );
}
